module.exports = __webpack_public_path__ + "media/quest-click.bebd3b1e.ogg";